import { Checkbox } from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const productDataColumn = ({
  selectionModel,
  handleOnSelectProduct,
}) => [
  {
    field: 'actions',
    type: 'actions',
    width: 70,
    headerClassName: 'p-1',
    renderHeader: () => <Checkbox label="" color="primary" disabled />,
    renderCell: ({ row }) => {
      return (
        <Checkbox
          label=""
          color="primary"
          checked={selectionModel.includes(row.id)}
          value={row.is_selected}
          name="customer_selected"
          onChange={(e) =>
            handleOnSelectProduct(
              {
                target: {
                  name: 'is_selected',
                  value: parseInt(row.is_selected) === 1 ? 0 : 1,
                },
              },
              row,
            )
          }
        />
      );
    },
  },
  {
    field: 'product_code',
    headerName: 'Product Code',
    minWidth: 120,
    flex: 1,
  },
  {
    field: 'product_name',
    headerName: 'Product Name',
    minWidth: 280,
    flex: 1,
  },
  {
    field: 'product_segment',
    headerName: 'Product Segment',
    minWidth: 180,
    flex: 1,
    valueGetter: ({ row }) => row.product_segment?.segment_name,
  },
  {
    field: 'supplier',
    headerName: 'Supplier',
    minWidth: 180,
    flex: 1,
    valueGetter: ({ row }) => row.get_supplier?.company_name,
  },
  {
    field: 'stock_level',
    headerName: 'Current Level',
    minWidth: 180,
    type: 'number',
    flex: 1,
  },
  {
    field: 'supplier_lead_time',
    headerName: 'Lead Time',
    minWidth: 180,
    type: 'number',
    flex: 1,
    renderCell: ({ row }) => (
      <Link to={'/view/products/list/' + row.product_code}>
        {row.supplier_lead_time}
      </Link>
    ),
  },
  {
    field: 'contract_status',
    headerName: 'Contract Status',
    minWidth: 180,
    flex: 1,
    renderCell: ({ row }) => renderContract(row),
  },
  {
    field: 'contract_remarks',
    headerName: 'Remarks',
    minWidth: 180,
    flex: 1,
    renderCell: ({ row }) => renderRemarks(row),
  },
];

const renderContract = ({ contract_status }) => {
  // if today is between contract from and contract to, then return active
  if (contract_status === 'Active') {
    return <span className="badge badge-success">Active</span>;
  }

  // if today is before contract from, then return upcoming
  if (contract_status === 'Upcoming') {
    return <span className="badge badge-warning">Upcoming</span>;
  }

  // if today is after contract to, then return expired
  if (contract_status === 'Expired') {
    return <span className="badge badge-danger">Expired</span>;
  }

  return <span className="text-danger">{contract_status}</span>;
};

const renderRemarks = ({ contract_remarks }) => {
  // check first if the contract dates is not empty else return empty
  if (!contract_remarks || contract_remarks === '') {
    return '';
  }

  return <span className="text-danger"> {contract_remarks} </span>;
};
